import React from 'react'
import { FaPencil } from "react-icons/fa6";


function Conponents() {
  return (
    <div style={{ backgroundColor: "white", color: "black",width:"100%" }}>
    <div style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
      <h2>Components </h2>
  
    </div>
    <div style={{
        backgroundColor: "#f0f0f0",
         borderTop: "2px solid #004aad",
         padding: "30px",
         margin: "10px 0",
         boxSizing: "border-box",
      }}>
<h5 style={{color:"#004aad",}}>GUM WORK COMPOSITE</h5>
<div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
  <label htmlFor="pricingFor" style={{ fontWeight: "bold", marginRight: "10px" }}>
    Presence *
  </label>
  <select
    id="pricingFor"
    name="pricingFor"
    style={{
      
      padding: "8px",
      borderRadius: "5px",
      width:"30%",
      marginLeft:"10%"
    }}
  >
    <option value="individual">Individual</option>
    <option value="group">Group</option>
  </select>
</div>
</div>
<br/>
<div>
  <button style={{
        marginTop: "20px",
        backgroundColor: "#004aad",
        color: "white",
        padding: "10px 15px",
        borderRadius: "5px",
        border: "none",
        cursor: "pointer",
    
       }}>
        <FaPencil /> Save
    </button>
</div>
  </div>
  )
}

export default Conponents

